<app-dialog-header [title]="'Cadastro de convidado'"></app-dialog-header>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="container">
      @if (errorMessage) {
        <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
      }
      @if (!participant) {
        <div class="row my-2">
          <div class="col">
            <label class="form-label" for="courtesy_ticket">Ingresso da cortesia</label>
            <select id="courtesy_ticket" class="form-select" formControlName="ticket_id">
              <option [ngValue]="null">{{ loadingTickets ? "Carregando ingressos..." : "Selecione o ingresso e o lote" }}</option>
              @for (ticket of tickets; track ticket.id) {
                <option [ngValue]="ticket.id">{{ ticket.title }} — {{ ticket.batch_label }} · {{ ticket.available_quantity }} disponíveis</option>
              }
            </select>
            @if (controls.ticket_id.touched && controls.ticket_id.hasError("required")) {
              <div class="text-danger">Selecione o ingresso que deseja conceder.</div>
            }
            @if (!loadingTickets && tickets.length === 0) {
              <p class="text-muted my-2">Não há ingressos disponíveis para cortesia no momento.</p>
            }
          </div>
        </div>
        @if (selectedTicket; as ticket) {
          <div class="courtesy-summary" aria-live="polite">
            <strong>{{ controls.quantity.value || 0 }} × {{ ticket.title }} — {{ ticket.batch_label }}</strong>
            <div>Cortesia · R$ 0,00 · {{ (controls.quantity.value || 0) * ticket.access_units }} {{ (controls.quantity.value || 0) * ticket.access_units === 1 ? "ingresso incluído" : "ingressos incluídos" }}</div>
            <div>O convidado pode aceitar até {{ ticket.expires_at | date: "dd/MM/yyyy HH:mm" }}.</div>
          </div>
        }
      } @else {
        <div class="courtesy-summary">
          <strong>{{ participant.ticket?.title || "Convite de cortesia" }}@if (participant.ticket?.batch_label) { — {{ participant.ticket?.batch_label }} }</strong>
          <div>Para alterar o ingresso ou a quantidade, cancele este convite e envie outro.</div>
        </div>
      }
      <div class="row my-2">
        <div class="col">
          <div class="form-group">
            <label class="form-label" for="email">E-mail</label>
            <div>
              <input
                placeholder="Email do convidado"
                type="email"
                class="form-control"
                id="email"
                formControlName="user_email" />

              @if (controls.user_email.touched && controls.user_email.hasError("required")) {
                <div class="text-danger">Esse campo é obrigatório.</div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <label class="form-label" for="user_phone_number">Telefone</label>
        <div class="form-group form-phone">
          <app-ddi-select formControlName="ddi"></app-ddi-select>
          <input
            placeholder="Telefone do convidado"
            type="phone"
            class="form-control"
            id="user_phone_number"
            formControlName="user_phone_number"
            [mask]="controls.ddi.value === '+55' ? '(00) 00000-0000' : ''"
            [ngClass]="{
              'is-invalid': controls.user_phone_number.invalid && controls.user_phone_number.touched,
            }" />
        </div>
        @if (controls.user_phone_number.touched && controls.user_phone_number.hasError("required")) {
          <div class="text-danger">Esse campo é obrigatório.</div>
        }
        @if (controls.user_phone_number.touched && controls.user_phone_number.hasError("invalidPhoneNumber")) {
          <div class="text-danger">Formato inválido, informe apenas os números.</div>
        }
      </div>
      <div class="row my-2">
        <div class="col">
          <label class="form-label" for="quantity">Quantidade de ingressos</label>
          <div class="form-group">
            <input
              placeholder="001"
              type="number"
              class="form-control"
              id="quantity"
              min="1"
              formControlName="quantity" />
          </div>
          @if (controls.quantity.touched && controls.quantity.hasError("required")) {
            <div class="text-danger">Esse campo é obrigatório.</div>
          }
          @if (controls.quantity.touched && (controls.quantity.hasError("min") || controls.quantity.hasError("pattern"))) {
            <div class="text-danger">Informe uma quantidade inteira maior que zero.</div>
          }
          @if (controls.quantity.touched && controls.quantity.hasError("max")) {
            <div class="text-danger">A quantidade escolhida não está disponível.</div>
          }
        </div>

        <div class="col">
          <label class="form-label" for="transferable">Esse ingresso é transferível?</label>
          <input class="form-check-input" type="checkbox" formControlName="transferable" id="transferable" />
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <div class="form-group">
            <label class="form-label" for="description">Descrição</label>
            <div>
              <textarea
                placeholder="Uma breve descrição do convidado"
                type="text"
                class="form-control"
                id="description"
                [formControl]="controls.description"
                rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="outlined" (btnClick)="dialogRef.close()">Fechar</app-button>
  <app-button (btnClick)="confirm()" [disabled]="loading || loadingTickets || (!participant && tickets.length === 0)">
    {{ participant ? "Editar convidado" : "Adicionar convidado" }}
  </app-button>
</mat-dialog-actions>
